// js
import React from 'react';
import PropTypes from 'prop-types';
// css
import '../../styles/components/sources/PeakBufferInput.scss';


const PeakBufferInput = ({ value, onChange, disabled }) => {

  return (
    <div className='PeakBufferInput SourcesHeaderInput'>
      <span className='PeakBufferInput__label SourcesHeaderInput__label'>
        Peak Buffer:
      </span>
      <span className='PeakBufferInput__input SourcesHeaderInput__input'>
        <input
          type='text'
          className='sources-header__peak-buffer-input'
          value={value}
          onChange={onChange}
          disabled={disabled}
        /> %
      </span>
    </div>
  );
};

PeakBufferInput.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired
};

export default PeakBufferInput;




// WEBPACK FOOTER //
// ./src/components/sources/PeakBufferInput.js